import global from '../../static/styles/global.scss';

import './components/_menu'
import './components/_sliders'
import './components/_choices'
import './components/_smooth-scroll-anchor'

import './components/_accordions'